export default __webpack_public_path__ + "static/media/image-space-capsule-portrait.dd0ac138.jpg";